import { MsalService } from '@azure/msal-angular';

export async function handleMsalRedirect(msal: MsalService): Promise<void> {
  try {
    const result = await msal.instance.handleRedirectPromise();
    const account =
      result?.account ?? msal.instance.getActiveAccount() ?? msal.instance.getAllAccounts()[0];
    if (account) {
      msal.instance.setActiveAccount(account);
    }
  } catch (err) {
    console.error('[MSAL] Error en handleRedirectPromise:', err);
  }
}
